import { AuthContextProvider } from "./auth-context";
import { SelectedContextProvider } from "./select-context";
import { OrderFilterProvider } from "./order-filter";
import { FactorFilterProvider } from "./factor-filter";
import { ProductStatsFilterProvider } from "./productStats-filter";

export default function ContextProviders(props) {
    return (
        <AuthContextProvider>
            <SelectedContextProvider>
                <OrderFilterProvider>
                    <FactorFilterProvider>
                        <ProductStatsFilterProvider>
                            {props.children}
                        </ProductStatsFilterProvider>
                    </FactorFilterProvider>
                </OrderFilterProvider>
            </SelectedContextProvider>
        </AuthContextProvider>
    )
}
